export const BUYER_HEADER_FEATURE_NAME = 'generic';
